import React, { Component } from 'react'
import HeaderLine from '../components/headerLine/headerLine'

class MainPage extends Component {
    render(){
        return(
            <HeaderLine header="Liste" />
        )
    }
}

export default MainPage